import { Component, Inject, OnInit } from '@angular/core';
import { UtilityService } from '../../services/utility-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-display-dialog',
  templateUrl: './display-dialog.component.html',
  styleUrls: ['./display-dialog.component.css']
})
export class DisplayDialogComponent implements OnInit {

  public l_title: string;
  public l_message: string;
  public l_backgroundColor: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) 
    public l_modalData: any,
    private l_referanceDialog: MatDialogRef<DisplayDialogComponent>
  ) { }

  ngOnInit(): void {
    console.log('l_modalData ===> ', this.l_modalData);
    this.l_title = this.l_modalData?.l_title;
    this.l_message = this.l_modalData?.l_message;
    this.l_backgroundColor = this.l_modalData?.l_colour;
  }

  async lFN_closeDialog() {
    this.l_referanceDialog.close();
  }

  lFN_IsHtml(message: string): boolean {
    const doc = new DOMParser().parseFromString(message, 'text/html');
    return doc.body.innerHTML !== message;
  }

}
